export default {
  // Update me with user
  updateHelp(state, data) {
    state.help = data;
  },
};
